const calculateOptimizedSizeProposal = (file, width, height) => {
  if (!file?.width || !file?.height) return {};

  const maxDimension = 1500;
  const scaledWidth = Math.round(file.width / 3);
  const scaledHeight = Math.round(file.height / 3);

  let returnWidth = scaledWidth;
  let returnHeight = scaledHeight;

  if (scaledWidth > maxDimension || scaledHeight > maxDimension) {
    if (scaledWidth > scaledHeight) {
      returnWidth = maxDimension;
      returnHeight = Math.round(maxDimension * (scaledHeight / scaledWidth));
    } else {
      returnWidth = Math.round(maxDimension * (scaledWidth / scaledHeight));
      returnHeight = maxDimension;
    }
  }

  return {
    width: returnWidth,
    height: returnHeight,
    ratio: scaledHeight / scaledWidth,
    alt_width_by_width: width,
    alt_height_by_width: Math.round(width * (scaledHeight / scaledWidth)),
    alt_width_by_height: Math.round(height * (scaledWidth / scaledHeight)),
    alt_height_by_height: height,
  };
};

export default calculateOptimizedSizeProposal;
